import AssetDocumentsListMobile from "./AssetDocumentsListMobile";

export default AssetDocumentsListMobile;
